import { render, staticRenderFns } from "./_Market.vue?vue&type=template&id=f3ee5aac&scoped=true&"
import script from "./_Market.vue?vue&type=script&lang=js&"
export * from "./_Market.vue?vue&type=script&lang=js&"
import style0 from "./_Market.vue?vue&type=style&index=0&id=f3ee5aac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ee5aac",
  null
  
)

export default component.exports